/**
 * 状態の札。色は tone(success / warning / danger / info / neutral)だけで決める。
 *
 * 「どの状態がどの tone か」は各アプリの constants(`employeeStatusTone` など)に置き、
 * tone → 色の対応は **ここと ui.css の 1 か所**。antd `Tag` の色名を画面ごとに
 * 選ぶのをやめる。
 */
import type { ReactNode } from "react";

export type Tone = "success" | "warning" | "danger" | "info" | "neutral";

export function StatusTag({
  tone,
  dot = false,
  children,
  title,
}: {
  tone: Tone;
  /** 塗りの札ではなく「● 文字」(表の中向け) */
  dot?: boolean;
  children: ReactNode;
  title?: string;
}) {
  return (
    <span className={`ui-status ui-status--${tone}${dot ? " is-dot" : ""}`} title={title}>
      {dot && <span className="ui-status-dot" aria-hidden />}
      {children}
    </span>
  );
}
